<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2.8" y="4" width="14.4" height="9.6" rx="1.8"/><path d="M7.4 16.6h5.2M10 13.6v3"/></svg>
</template>
